// Fixed colors (from the XD): Temas by their order (by Spanish name, as the API sends them),
// Subtemas by their order in /api/themes, so each keeps its color in every tab.
export const THEME_COLORS = ['#FFC62E', '#CE281B', '#59AAC6'];
export const SUBTHEME_COLORS = ['#FFC62E', '#BAB200', '#59AAC6', '#CE281B', '#384078', '#5C821C',
  '#80B4D1', '#F45E53', '#8BD2EA', '#6C7196', '#FFD667', '#1FB151'];

// Past the design's colors, hues spread by the golden angle keep every Subtema distinct.
export const subthemeColor = (index: number): string =>
  SUBTHEME_COLORS[index] || `hsl(${Math.round((index * 137.508) % 360)}, 55%, 50%)`;
